import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LoadsForAllProductsService } from '../root/loads-for-all-products.service';
import { LoHiAdminInProgressLoadListItem } from '../types';

@Pipe({
  name: 'inProgressLoadByPhoneV2',
})
export class InProgressLoadByPhoneV2Pipe implements PipeTransform {
  constructor(private loadsService: LoadsForAllProductsService) {}

  // tslint:disable-next-line
  public transform(phoneNumber: string): Observable<LoHiAdminInProgressLoadListItem> {
    return this.loadsService.inProgressLoadsPhoneMap$.pipe(
      map((loads) => {
        if (phoneNumber in loads) {
          return loads[phoneNumber];
        }
        return null;
      }),
    );
  }
}
